application.register("part_item_object_tile", class extends Stimulus.Controller {
    share(e) {
        e.stopPropagation();
        e.preventDefault();

        let options = JSON.parse(e.currentTarget.dataset.actionOptions);

        importScript(cdnjs.shareApiPolyfill,()=>{

            if(["cs","de", "da", "en", "es", "fr", "ja", "ko", "nl", "pt", "ru", "sk", "tr", "zh"].indexOf(lang) === -1) {
                lang = "en";
            }

            navigator.share({
                    title: options.title,
                    text: options.description,
                    url: options.url,
                },
                {
                    copy: true,
                    email: true,
                    print: false,
                    sms: false,
                    messenger: true,
                    facebook: true,
                    whatsapp: true,
                    twitter: true,
                    linkedin: true,
                    telegram: false,
                    skype: false,
                    language: lang
                }
            )
                .then()
                .catch( error => console.log(error));
        });
    }
});